
import { translate } from "react-i18next";
import * as React from "react";
import unescape from "lodash/unescape";
import { Button, DialogContainer, DialogHeader, DialogBody, DialogFooter } from "@wg/wows-react-uikit";

import { markupWithoutUrls } from "helpers/markup";
import ButtonGroup from "@wg/wows-react-uikit/ButtonGroup";

export type IProps = {
  isEditButtonShown: boolean;
  rawDescription: string;
  hideDialog: () => void;
  onDescriptionEditClick: () => void;
  t: (t: string) => string;
};

export class ClanDescriptionDialog extends React.PureComponent<IProps> {


  render() {
    const t = this.props.t;

    return <DialogContainer>
      <DialogHeader>{t('Описание клана')}</DialogHeader>
      <DialogBody>
        <pre>{unescape(this.props.rawDescription)}</pre>
      </DialogBody>
      <DialogFooter>
        <ButtonGroup>
          {this.props.isEditButtonShown ?
            <Button onClick={this.props.onDescriptionEditClick}>
              {t('Изменить описание')}
            </Button>
            : null}
          <Button onClick={this.props.hideDialog}>
            {t('Закрыть')}
          </Button>


        </ButtonGroup>
      </DialogFooter>
    </DialogContainer>;
  }
}

export default translate()(ClanDescriptionDialog);